import { cva, type VariantProps } from "class-variance-authority";

/**
 * Unified card surface styles for panels, detail blocks, dashboards, and glass overlays.
 * Keep in sync with `components.card` in tailwind-utils (default variant).
 */
export const cardVariants = cva(
  "bg-card text-card-foreground flex flex-col gap-6 outline-none",
  {
    variants: {
      variant: {
        /** Standard bordered card (forms, settings, default Shadcn-style). */
        default: "rounded-xl border py-6 shadow-sm",
        /** Soft dashboard panel: no border line, large radius, light shadow. */
        panel: "rounded-2xl border-0 py-6 shadow-sm",
        /** Frosted glass using semantic card tokens (works in light and dark). */
        glass:
          "rounded-xl border border-border/40 bg-card/80 py-6 shadow-sm backdrop-blur-md dark:bg-card/65",
        /** Primary-tinted callout (e.g. admin hints, selections). */
        accent:
          "rounded-xl border border-primary/20 bg-primary/5 py-6 shadow-sm",
        /** Top accent strip — list/toolbar shells (shift tabs, etc.). */
        highlight:
          "rounded-2xl border-0 border-t-2 border-t-primary/10 bg-card pt-0 pb-6 shadow-sm",
        /** Dashed outline — empty states and placeholders. */
        dashed:
          "rounded-2xl border border-dashed border-muted-foreground/25 bg-card py-4 shadow-sm gap-2"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);

export type CardVariantProps = VariantProps<typeof cardVariants>;
